import Marquee from "react-fast-marquee";
import { Fish, Wine } from "lucide-react";
import { useLang } from "@/i18n";
import { MarqueeBadge, Heart, PawPrint } from "@/components/FriendlyBadges";

const Dot = () => <span className="w-1.5 h-1.5 rounded-full bg-bordeaux/70" aria-hidden="true" />;

const EditorialMarquee = () => {
  const { t } = useLang();
  const items = [
    { icon: Wine, label: t.badges.wine, id: "wine" },
    { icon: Fish, label: t.badges.fish, id: "fish" },
    { icon: Heart, label: t.badges.lgbtq, id: "lgbtq" },
    { icon: PawPrint, label: t.badges.animal, id: "animal" },
  ];

  return (
    <div
      className="border-y border-sand/70 py-5 md:py-7 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <Marquee speed={26} gradient={false} pauseOnHover autoFill>
        {items.map((item) => (
          <span key={item.id} className="flex items-center">
            <span className="flex items-center mx-8 md:mx-12">
              <MarqueeBadge icon={item.icon} label={item.label} testId={`marquee-badge-${item.id}`} />
            </span>
            <Dot />
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
